{
    "SortAsc1Label": "1º Ascendente",
    "SortDsc1Label": "1º Descendente",
    "SortAsc2Label": "2º Ascendente",
    "SortDsc2Label": "2º Descendente",
    "SortAsc3Label": "3º Ascendente",
    "SortDsc3Label": "3ª Descendente",
    "SortNoneLabel": "[Não classificado por]",
    "SortAsc1Tooltip": "Classifique principalmente as linhas do relatório em ordem crescente pela estatística\/campo selecionado.",
    "SortDsc1Tooltip": "Classifique principalmente as linhas de relatório decrescentes pela estatística\/campo selecionado.",
    "SortAsc2Tooltip": "Classifique secundariamente em ordem crescente pela estatística\/campo selecionado.",
    "SortDsc2Tooltip": "Classifique secundariamente de forma decrescente pela estatística\/campo selecionado.",
    "SortAsc3Tooltip": "Classifique as linhas do relatório em ordem crescente pela estatística\/campo selecionado.",
    "SortDsc3Tooltip": "Classifique as linhas do relatório em 3ª ordem decrescente pela estatística\/campo selecionado.",
    "SortNoneTooltip": "Não classifique as linhas do relatório pela estatística\/campo selecionado.",
    "NAME": "SortList"
}